import fragment from './fragment'
import getResume from '../getResume'
import generateId from '@helpers/misc/generateId'

export default function optimisticUpdateCart({client, props, state, product}) {
  try {
    const {price, basePrice, amount, unitPrice, baseUnitPrice} = getResume(props, state, product)

    const data = client.readFragment({
      id: 'cart',
      fragment
    })

    client.writeFragment({
      id: 'cart',
      fragment,
      data: {
        ...data,
        items: [
          ...data.items,
          {
            _id: `pending:${generateId()}`,
            isOutOfStock: false,
            outOfStockMessage: null,
            amount,
            realPrice: baseUnitPrice,
            unitPrice,
            description: '',
            descriptionItems: [],
            product: {
              _id: product._id,
              name: product.name,
              __typename: 'Product'
            },
            __typename: 'CartItem'
          }
        ],
        itemsPrice: data.itemsPrice + price,
        realPrice: data.realPrice + basePrice,
        totalPrice: data.totalPrice + price,
        amountToPay: data.amountToPay + price
      }
    })
  } catch (error) {
    console.log('Error:', error)
  }
}
